import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from 'store/store';
import history from 'modules/overlay-canvas/addons/history';
import { setHasChanges, setSavedScheme } from 'modules/template-editor/store/editor/editor';
import { selectFabricManager } from 'modules/template-editor/store/editor/selectors';
import { updateBoard } from 'modules/template-editor/store/templates/actions';
import { selectActiveBoard } from 'modules/template-editor/store/templates/selectors';
import { resetPressedState } from 'modules/template-editor/store/templates/templates';
import useLocalStorage from './use-local-storage';

function useSaveScheme() {
  const dispatch = useDispatch<AppDispatch>();
  const activeBoardId = useSelector(selectActiveBoard)?.id;
  const manager = useSelector(selectFabricManager);
  const { getData, setData } = useLocalStorage();

  const saveScheme = useCallback(async () => {
    if (!manager) {
      throw new Error('No manager');
    }

    history.disableHistory();

    const { boardId, scheme } = getData();
    if (!boardId || !scheme) {
      throw new Error('No board id or scheme in local storage');
    }

    const currentScheme = manager.getScheme(true);

    setData({
      scheme: currentScheme,
      resolution: manager.resolution.value,
    });

    // `.unwrap()` обязателен: без него сохранение «удавалось» всегда, и вызывающий
    // (content.tsx, notice.tsx) рапортовал об успехе поверх упавшего запроса.
    await dispatch(
      updateBoard({
        id: activeBoardId ?? boardId,
        objects: currentScheme.objects,
        version: currentScheme.version,
      }),
    ).unwrap();

    dispatch(resetPressedState());
    dispatch(setSavedScheme(currentScheme));
    dispatch(setHasChanges(false));

    history.activeHistory();
    history.saveState();
  }, [activeBoardId, dispatch, getData, manager, setData]);

  return { saveScheme };
}

export default useSaveScheme;
